module.exports = __webpack_public_path__ + "static/media/Placaj-Ceramic-Klinker-250-X-65-X-10---Teracota-(07).a55c2ce0.jpg";